"use client";

import React from "react";

export default function VideoGalleryCardSkeleton({ variant = 'default' }: { variant?: 'default' | 'light' }) {
  const isLight = variant === 'light';
  return (
    <article
      className={
        "w-full overflow-hidden rounded-2xl border border-zinc-200/60 dark:border-zinc-800 shadow-sm animate-pulse " +
        (isLight ? "bg-white text-zinc-900" : "bg-card text-card-foreground")
      }
    >
      {/* Thumbnail area to match 16:9 aspect */}
      <div className="relative w-full aspect-[16/9]">
        <div className="absolute inset-0 skeleton" aria-hidden />
      </div>
      {/* Body area to match real card padding/heights */}
      <div className="p-5 min-h-[96px] flex flex-col justify-between">
        <div className="h-5 w-3/4 skeleton rounded mb-2" />
        <div className="h-3 w-1/3 skeleton rounded" />
      </div>
    </article>
  );
}
